import i18n from 'i18next';
import { AirportFragment, SegmentWithTransferFragment } from '@websky/graphql';

export const getTransferShortLabel = (segments: SegmentWithTransferFragment[]): string => {
	if (segments.length > 1) {
		const transfers: string[] = [];

		segments.forEach(({ segment }, index) => {
			if (index > 0) {
				transfers.push(segment.departure.airport.iata);
			}
		});

		return `${transfers.length} ${i18n.t('MobileSegmentInfo:stop')} ${i18n.t(
			'MobileSegmentInfo:in'
		)} ${transfers.join(', ')} • `;
	}

	return '';
};

export const isDifferentAirportName = (airport: AirportFragment): boolean => {
	return airport.city && airport.city.name !== airport.name;
};

export interface TransferInfo {
	transfersCount: number;
	iata: string[];
}

// this function used in new version of mobileSegmentInfo component
export const getTransferInfo = (segments: SegmentWithTransferFragment[]): TransferInfo => {
	if (segments.length < 1) {
		return {
			iata: null,
			transfersCount: 0
		};
	}

	const transfersIata = segments.slice(1).map(segment => segment.segment.departure.airport.iata);

	return {
		iata: transfersIata,
		transfersCount: transfersIata.length
	};
};
